import {
    http,
} from '../services';

class AutorService {

    async autorForm() {
        return http.get('/autores/form');
    }

    async getAll({ pageIndex, rowsPerPage, columnSort, orderSort, searchIndex, searchText, searchOperator }) {
        return http.get('/autores', {
            pageIndex,
            rowsPerPage,
            columnSort,
            orderSort,
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    async getCount({ searchIndex, searchText, searchOperator }) {
        return http.get('/autores/count', {
            searchIndex,
            searchText,
            searchOperator,
        });
    }

    async getAutores(projeto) {
        return http.get('/autores', { projeto });
    }

    aceitaTermo(autor, projeto) {
        return http.put('/termo', {autor, projeto});
    }
   /* save(autor) {
        return http.post('/autores', autor);
    }*/

    update(autor) {
        return http.put('/autor', autor);
    }

/*
    delete(autor) {
        return http.delete('/autores', autor);
    }*/
   
}

const autorService = new AutorService();
export default autorService;